const mixin = {
  methods: {
    generatedSvgName(name) {
      return name.replace(' ', '_')
    },
    hasProductDetails(item) {
      const hasTechnicalNotes = item.technical_notes.length > 0
      const hasFeatures = item.features.length > 0
      const hasTastingNotes = item.tasting_notes.length > 0

      return (hasTechnicalNotes || hasFeatures || hasTastingNotes || item.wine_making.length > 0 || item.prev_tasting_notes.length > 0)
    },
    retrieveConcilioLayoutSetting(payload) {
      const concilioSettingsExist = this.concilioSettings !== null
      const currentLayout = this.carouselItemLayout
      const layoutSettingsExist = (concilioSettingsExist) ? Object.keys(this.concilioSettings).includes(currentLayout) : false

      return (concilioSettingsExist) ? layoutSettingsExist ? this.concilioSettings[currentLayout][payload] : null : null
    }
  }
}

export default mixin
